import { ComponentStyleConfig } from '@chakra-ui/react';

export const FormLabel: ComponentStyleConfig = {
  baseStyle: {
    lineHeight: 1.1,
    marginBottom: { base: 2, md: 0 },
  },
};
